module.exports = __webpack_public_path__ + "img/space-invadors.ba195d03.png";